module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "epigraphPage",
    attrs: {
      "id": "epi01"
    }
  }, [_c('div', {
    staticClass: "epigraph"
  }, [_c('p', {
    staticClass: "epigraphText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The relationship of man to woman is the most natural relationship of human being to human being. From the quality of that relationship, the whole level of development of the species can be assessed.")])]), _vm._v(" "), _c('p', {
    staticClass: "epigraphSource"
  }, [_vm._v("-Karl Marx")])]), _vm._v(" "), _c('div', {
    staticClass: "epigraph"
  }, [_c('p', {
    staticClass: "epigraphText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("But he never had this chance to be alone. His body was in the service of others. There was no pause in life. A man was picked up in the tempo of this life, and couldn’t get off it. The body had no time to reflect. It spent its energies working for other bodies. It developed co-operative reflexes instead of expressive ones.")])]), _vm._v(" "), _c('p', {
    staticClass: "epigraphSource"
  }, [_vm._v("-Alan Harrington")])]), _vm._v(" "), _c('div', {
    staticClass: "epigraph"
  }, [_c('p', {
    staticClass: "epigraphText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Perhaps everything terrible is in its deepest being something helpless that wants help from us.")])]), _vm._v(" "), _c('p', {
    staticClass: "epigraphSource"
  }, [_vm._v("-Rainer Maria Rilke")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dd1c32e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contoursofdarkness_epi01.vue
// module id = 75
// module chunks = 0